module.exports = __webpack_public_path__ + "media/images/sample/product-3-954f73d99bb3ae9d22150d3386c0dde1.png";